<template>
  <div>
    <div class="auto-height">
      <div class="card measure-side-header">
        <div class="card-body" style="padding-left:12px; height: 93px;">
          <h5 class="mb-0">
            {{ $t('maintenance.framework_control.table.control_objectives_title') }}
          </h5>
          <span class="text-success cursor-pointer" v-if="selectedFilter.id" @click="resetSelected">
            {{ $t('administration.users.create.reset_organization_label') }}
          </span>
        </div>
      </div>

      <!-- <b-form-input
        type="text"
        v-model="filters.keywordValue"
        class="search-bar-category"
        qid="search-c-input"
        v-on:input="debounceInput"
        :placeholder="$t('maintenance.control_objective.search_placeholder')"
      ></b-form-input> -->

      <div v-for="(object, index) in tableItems"
          :key="'category-row-' + index"
          :id="'category-row-' + index"
          class="filter-tree-item item-block cursor-pointer"
          :class="{'filter-tree-selected': selectedFilter.id == object.id}"
          @click="updateSelected(object)"
      >

        <b-popover
            :target="'category-row-' + index"
            boundary="viewport"
            triggers="hover"
            placement="topleft"
            :delay="{ show: 500, hide: 0 }"
        >
          <div v-if="object.description" class="mt-2">
            <span class="text-bold">
              {{ $t('maintenance.framework_control.create.description_label') }}:
            </span>
            <br>
            {{ object.description | truncate(200)}}
            <br>
          </div>
        </b-popover>

        <span class="cursor-pointer" :title="object.name">
          <font-awesome-icon icon="book"/>
          {{ object.name }}
        </span>
      </div>

      <div v-if="!loading && !tableItems.length">
        <div class="card measure-side-header">
          <div class="card-body" style="padding-left:12px;">
            <h5 class="mb-0">
              {{ $t('system.no_results') }}
            </h5>
          </div>
        </div>
      </div>

      <div class="mt-5" v-if="loading">
        <div class="swing-container">
          <div class="swing">
            <div class="swing-l"></div>
            <div></div>
            <div></div>
            <div></div>
            <div class="swing-r"></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import roleCheck from "@/util/ACL/roleCheck"

export default {
  name: 'FrameworkSideFilter',
  data: function() {
    return {
      loading: true,
      selectedFilter: {},
      tableItems: [],
      keywordValue: '',
      filters: {
        keywordValue: ''
      },
    }
  },
  props: {
    selectedControlObjective: [],
    updateList: {},
    framework: {},
    selectedControlObjectiveDeleted: false,
  },
  watch: {
    getClient: function () {
      this.loadItems();
    },
    selectedFilter: function () {

    },
    updateList: function (newValue, oldValue) {
      if (newValue) {
        this.loadItems()
      }
    },
    // Watcher for selected Control Objective - when selected item is changed from external component
    selectedControlObjective: function (newValue, oldValue) {
      let self = this;

      if (newValue) {
        if (this.selectedControlObjectiveDeleted) {
          this.updateSelectedFromParent();
        } else {
          if (this.selectedControlObjective.id > 0) {
            this.updateSelectedFromParent(newValue);
          }
        }
      } else {
        if (this.selectedControlObjective) {
          this.resetSelectedWithReload();
        }
      }
    },
    getselectedFilter: function (newValue, oldValue) {
      this.$emit('updateFilter', newValue)
    },

  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getselectedFilter() {
      return this.selectedFilter
    }
  },
  methods: {
    loadItems() {
      let self = this;
      this.loading = true;
      piincHttp.get('control-objectives', { params:
        {
          per_page: 100,
          framework: this.framework.id,
          client: this.getClient.slug,
          keyword: this.filters.keywordValue !== '' ? this.filters.keywordValue : undefined
        }
      }).then(function(response) {
        self.loading = false;
        self.tableItems = response.data.items;
      }, function() {});
    },

    // Function for updating selected filter - when user clicks on item
    updateSelected(item) {
      if (item && item.id) {
        // If new item is different from the last one
        if (item.id != this.selectedFilter.id) {
          // Select new item and emit event that we updated selected item
          this.selectedFilter = item
          this.$emit('updateSelected', item)
        } else {
          // If new item is same as previous one - deselect the item
          this.resetSelected()
        }
      }
    },

    // Function for updating selected filter - from parent component
    updateSelectedFromParent(item) {
      let self = this;
      // First reset previous filter
      this.selectedFilter = {}

      // Then call api to get new data for list (because we changed name on one of them)
      piincHttp.get('control-objectives', { params:
        {
          per_page: 100,
          framework: this.framework.id,
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.loading = false;
        self.tableItems = response.data.items;

        if (item && item.id) {
          // Set selected filter now with new item provided from parent component
          self.selectedFilter = item
          // Emit event that selected item is updated
          self.$emit('updateSelected', item)
        }else{

          if (self.selectedControlObjectiveDeleted) {
            self.selectedControlObjectiveDeleted = false
          }else{
            self.$emit('updateSelected')
          }
        }
      }, function() {});
    },

    resetSelected() {
      this.selectedFilter = {};
      this.selectedFilterName = '';
      this.$emit('updateSelected')
    },
    resetSelectedWithReload() {
      this.selectedFilter = {};
      this.selectedFilterName = '';
      this.loadItems();
      this.$emit('updateSelected');
    }
  },
  created () {
    let self = this;
    if (this.getClient && this.getClient.slug) {
      this.loadItems();
    }
  }
}
</script>
